import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import './index.css';

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import AuthenticationProvider, { msalConfig } from './msalConfig';
import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { Admin } from './components/Admin';
import { msalInstance } from './msalConfig';
import { EventType } from '@azure/msal-browser';
import { loginRequest } from './msalConfig';
import { callMsGraph } from './App';
import App from './App';
import { Home } from './components/Home';
import { BrowserRouter, Router } from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
      <App />
     
  
);
//ReactDOM.render(<App />, document.getElementById('root'));
